export const ROUTES = {
  HOME: '/',
  UN_AUTHORIZED: '/un-authorized',
  DASHBOARD: '/dashboard',
};
